import React from 'react';
import { injectIntl } from 'react-intl';
import { Grid, Switch } from '@mui/material';
import Typography from '@mui/material/Typography';

const TypoStyle = {
  whiteSpace: 'nowrap',
  fontSize: '16px'
};

const ModeSwitch = props => {
  const { intl, checked, onChange } = props;

  return (
    <Typography component="div" style={TypoStyle}>
      <Grid container wrap="nowrap" spacing={1} sx={{
        alignItems: "center"
      }}>
        <Grid>{intl.formatMessage({ id: 'fin-py-handwriting-mode' })}</Grid>
            <Grid style={{ fontSize: '75%' }}>
              ({intl.formatMessage({ id: 'beta' })})
            </Grid>
        <Grid>
          <Switch color="primary" checked={checked} onChange={onChange} />
        </Grid>
      </Grid>
    </Typography>
  );
};

export default injectIntl(ModeSwitch);
